<template>
    <span class="select-wrapper">
        <select :class="`form__field form__field--select ${(this.def ? `form__field--${this.def} --${this.def} js-${this.def}` : '' )}`"
                :name="def" :id="def"
                :value="internalValue"
                :readonly="readOnly"
                :disabled="disabled"
                @change="onChange"
                @keydown="$emit('keydown', $event)"
                @keypress="$emit('keypress', $event)"
                @keyup="$emit('keyup', $event)"
                @keyup.enter="$emit('keyup.enter', $event)"
                @mousedown="$emit('mousedown', $event)"
                @mouseover="$emit('mouseover', $event)"
                @mouseup="$emit('mouseup', $event)"
                @touchstart="$emit('touchstart', $event)"
                @touchend="$emit('touchend', $event)"
                @touchcancel="$emit('touchcancel', $event)">
            <option v-for="option in options"
                    :value="option.value == 0 ? 0 : option.value ? option.value : option"
                    :key="kebabCase(option.text ? option.text : option)"
                    :selected="isSelected(option)">{{ option.text ? option.text : option }}</option>
        </select>
    </span>
</template>

<script>

import Casing from '@/helpers/casing'

import FormControl from './form-control'

export default {

    props: {
        placeholder: {
            type: String,
            default: '',
        },
        value: {
            type: [ String, Number, Boolean ],
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        FormControl,
    ],

    data() {
        return {
            internalValue: this.value,
        }
    },

    watch: {

        value(newValue) {
            this.internalValue = newValue
        },
    },

    methods: {

        /**
         * Indicates whether the item is the currently selected item or not.
         *
         * @param {Object} item The item from the options array.
         */
        isSelected(option) {
            return option.value === this.internalValue
                || option === this.internalValue
                || option.value == this.internalValue ? parseInt(this.internalValue) : null
        },

        /**
         * Returns the kebab cased version of the provided value.
         *
         * @param {string} value The string to manipulate.
         */
        kebabCase(value) {
            return Casing.kebabCase(value)
        },

        /**
         * Event that fires on change of the control value.
         * For Vue v-model support this also triggers an input event back up the component stack.
         *
         * @param {Object} ev The event data.
         */
        onChange(ev) {
            this.internalValue = Number.isNaN(ev.target.value) ? null : parseInt(ev.target.value)
            this.$emit('change', this.internalValue)
            this.$emit('input', this.internalValue)
        },
    },
}

</script>
